(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-text"] && !Shopify.designMode) return;
  try {
    

 var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
              new TxtType(elements[i], JSON.parse(toRotate), period);
            }
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
        document.body.appendChild(css);
    };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["training-program-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  const init = root => {
    if (!root || root.dataset.trainingInitialized === 'true') return;
    root.dataset.trainingInitialized = 'true';
    const tabs = root.querySelectorAll('.training-tab');
    const items = root.querySelectorAll('.grid__item.grid-product');
    const hydrateHover = target => {
      const image = target?.closest('.card')?.querySelector('[data-hover-src]');
      if (!image) return;
      image.src = image.dataset.hoverSrc;
      if (image.dataset.hoverSrcset) image.srcset = image.dataset.hoverSrcset;
      delete image.dataset.hoverSrc;
      delete image.dataset.hoverSrcset;
    };
    root.addEventListener('pointerover', event => hydrateHover(event.target), { passive: true });
    root.addEventListener('focusin', event => hydrateHover(event.target));
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(item => {
          const active = item === tab;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', String(active));
        });
        const cat = tab.dataset.category;
        items.forEach(item => {
          const isHidden = !item.classList.contains(cat);
          item.classList.toggle('hidden', isHidden);
          item.hidden = isHidden;
        });
      });
    });
  };
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector?.('[data-training-section]') || event.target));
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-training-section]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
